import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "border border-primary-subtle p-3" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-4" }, null, -1)
const _hoisted_5 = { class: "input-group mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-microphone" }, null, -1)
const _hoisted_7 = {
  class: "w-100 my-2 p-2",
  rows: "2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-50" }, null, -1)
const _hoisted_9 = { class: "border border-primary-subtle p-3 mt-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "画像を生成する", -1)
const _hoisted_11 = {
  key: 0,
  class: "sm:col-span-2"
}
const _hoisted_12 = { class: "row w-100" }
const _hoisted_13 = { class: "col-sm-12 col-md-3 p-4" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "col-sm-12 col-md-3 p-4" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "col-sm-12 col-md-3 p-4" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "col-sm-12 col-md-3 p-4" }
const _hoisted_20 = ["src"]

import { ref,Ref } from "vue";
import { SessionUser } from "../../utils/SessionUser";
import { translation } from "../../lang/Translation";
import {translationToEn} from "./translationToEn"
import OptionPageHeader from "../../components/header/OptionPageHeader.vue";
import {initSpeechToText} from "./SpeechToText"
import { MessageDialog } from '../../../framework/frontend/MessageDialog';
import { WordToImageCanvasARService } from '../../biz/remote/WordToImageCanvasARService';
import LoadingView from "../../components/common/LoadingView.vue";
import axios from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'WordToCanvasArPage',
  setup(__props) {

const t = translation;

// let recognition:any = null;
const speechToTextButton = ref("音声認識")
const recognitionWords = ref("")
const promptExchanged = ref("")
const imagePaths:Ref<string[]> = ref([]);
const loading:Ref<boolean> = ref(false)

/**
 * 音声認識のハンドラ 
 */
let isRecognizing = false;
const onStart =()=>{
  isRecognizing = true;
  speechToTextButton.value = "停止"
}
const onEnd =()=>{
  isRecognizing = false
  speechToTextButton.value = "音声認識"
}
const onResult = async (transcript:string,isFinish:boolean)=>{
  recognitionWords.value = transcript;
  if(isFinish){
    console.log("finish")
    promptExchanged.value =  await translationToEn(recognitionWords.value);
  }
}
const recognition = initSpeechToText( onStart,onEnd,onResult)

/**
 * 音声認識開始
 */
const speechToText = ()=>{
  if(!recognition){
    return;
  }
  console.log("isRecognizing",isRecognizing)
  if (isRecognizing) {
      recognition.stop();
    } else {
      recognitionWords.value = "";
      recognition.start();
    }

  recognition.start();
}

/**
 * 翻訳ボタン（音声認識後は、自動で翻訳する）
 */
const translationToEnButton = async ()=>{
  promptExchanged.value = await translationToEn(recognitionWords.value);
}

/**
 * 画像の生成
 */
const createImage = async ()=>{
  const biz = new WordToImageCanvasARService();
  loading.value = true;
  const result = await biz.createImageByPrompt(promptExchanged.value)
  if(result.hasError){
    await MessageDialog.error(result.errorDescription);
    return;
  }
  console.log("result",result)
  imagePaths.value = result.data;
  loading.value =false
}

/**
 * 画像を保存
 */
const uploadImage = async (filePath:string)=>{
  console.log(filePath);

  const imageResponse = await axios.get(filePath,{ responseType: 'blob' })
  const files = imageResponse.data

  const size =  files.size;
  MessageDialog.info( `ファイルアップロードを開始しました。サイズ:${size}` )
  const formData = new FormData();
  formData.append("userfile", files, filePath); // サーバーサイドの[user_assets_api.ts->uploadMultの名前と合わせる]
  const url = new URL(location.href);
  url.pathname = `/webapi/file/fileupload_api`;
  url.searchParams.append("user_id", `${SessionUser.instance.userId}`);
  url.searchParams.append("token", SessionUser.instance.token);
  try{
    const response = await axios.post(url.toString(), formData, {
      onUploadProgress: (e)=>{
        console.log("progress" ,e)
      }
    });

    // progress.value = 0;
    const fileName = response.data.Key;
    MessageDialog.info(`${fileName}${t.to("をアップロードしました", "uploaded")}`);
    
  }catch(e){
    console.error(e);
    MessageDialog.error(`ファイルアップロードでエラーが発生しました。`);
  }
}


const createARCanvas = async (filePath:string)=>{
  console.log(filePath)
  const fileName = filePath.split("/").reverse()[0];
  const biz = new WordToImageCanvasARService();
  const response = await biz.imageToCanvasModel(SessionUser.instance.userId,  fileName)
  MessageDialog.info( response.data)
}

const onBack =()=>{
  history.back();
}

const close = () => {
  onBack()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(OptionPageHeader, {
      "back-to": onBack,
      class: "mx-5"
    }),
    (loading.value)
      ? (_openBlock(), _createBlock(LoadingView, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t).to("言葉で絵を描く","word_to_image")), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recognitionWords).value = $event)),
              type: "text",
              class: "form-control rounded-lg",
              rows: "2"
            }, null, 512), [
              [_vModelText, recognitionWords.value]
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary btn-lg",
              onClick: speechToText
            }, [
              _createTextVNode(_toDisplayString(speechToTextButton.value) + " ", 1),
              _hoisted_6
            ]),
            _createElementVNode("button", {
              class: "btn btn-outline-secondary btn-lg",
              onClick: translationToEnButton
            }, "再翻訳 ")
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(promptExchanged.value), 1)
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("button", {
          class: "btn btn-primary btn-lg w-50 y-2",
          onClick: createImage
        }, "画像を生成する"),
        (imagePaths.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("img", {
                    id: "preview1",
                    src: imagePaths.value[0],
                    class: "img-fluid mb-3",
                    cwidth: "512",
                    height: "512"
                  }, null, 8, _hoisted_14),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-lg me-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (uploadImage(imagePaths.value[0])))
                  }, "画像保存")
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    id: "preview2",
                    src: imagePaths.value[1],
                    class: "img-fluid mb-3",
                    width: "512",
                    height: "512"
                  }, null, 8, _hoisted_16),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-lg",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (uploadImage(imagePaths.value[1])))
                  }, "画像保存")
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("img", {
                    id: "preview3",
                    src: imagePaths.value[2],
                    class: "img-fluid mb-3",
                    width: "512",
                    height: "512"
                  }, null, 8, _hoisted_18),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-lg",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (uploadImage(imagePaths.value[2])))
                  }, "画像保存")
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("img", {
                    id: "preview4",
                    src: imagePaths.value[3],
                    class: "img-fluid mb-3",
                    width: "512",
                    height: "512"
                  }, null, 8, _hoisted_20),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-lg",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (uploadImage(imagePaths.value[3])))
                  }, "画像保存")
                ])
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary btn-lg",
                onClick: close
              }, "閉じる")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})